module.exports = __webpack_public_path__ + "img/collection-diamondJewelryCollectionRings@2x.9940302.webp";